import React, { useEffect, useState } from "react";
import Heading from "../../components/Heading/Heading";
import NavBar from "../../components/NavBar/NavBar";
import "react-data-table-component-extensions/dist/index.css";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { promocodeListAPI, deletePromocode, UpdateStatusPromocodeAPI } from "../../api/apiHandler";
import { Link } from "react-router-dom";
import { exportToCSV } from "../Common/ExportToExcel";
import moment from "moment/moment";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import IconButton from "@mui/material/IconButton";
import { Dropdown } from "primereact/dropdown";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { discountTypeOption } from '../Common/CommonFunctions'
import Swal from 'sweetalert2';

export default function PromocodeList({ isLoader }) {
  const [selectedPromocodeType, setSelectedPromocodeType] = useState(null);
  const [promocodeData, setPromocodeData] = useState([]);
  const [discountType, setDiscountType] = useState([]);
  const [promocodeFilterData, setPromocodeFilterData] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [first, setFirst] = useState(0);
  const [sortColumn, setSortColumn] = useState("id");
  const [sortOrder, setSortOrder] = useState("ASC");
  const donor_id = localStorage.getItem("DAid");

  const StatusChangeFunc = async (promocode_id, status) => {
    const newStatus = status ? 1 : 0;

    const res = await UpdateStatusPromocodeAPI({ promocode_id, status: newStatus });
    if (res.data.code === "1") {
      setPromocodeData(prev =>
        prev.map(item =>
          item.id === promocode_id ? { ...item, is_active: newStatus } : item
        )
      );
      setPromocodeFilterData(prev =>
        prev.map(item =>
          item.id === promocode_id ? { ...item, is_active: newStatus } : item
        )
      );
    }
  };

  const columns = [
    {
      id: 2,
      name: "Id",
      label: "id",
      selector: (row) => row.id,
      sortable: true,
      cellExport: (row) => row.id,
    },
    {
      id: 3,
      name: "Name",
      label: "name",
      selector: (row) => row.name,
      sortable: true,
      cellExport: (row) => row.name,
    },
    {
      id: 4,
      name: "Uniqe Code",
      label: "unique_code",
      selector: (row) => row.unique_code,
      sortable: true,
      cellExport: (row) => row.unique_code,
    },
    {
      id: 5,
      name: "Discount type",
      label: "discount_type",
      selector: (row) => row.discount_type,
      sortable: true,
      cellExport: (row) => row.discount_type,
    },
    {
      id: 6,
      name: "Discount Value",
      label: "discount_value",
      selector: (row) => row.discount_value,
      sortable: true,
      cellExport: (row) => row.discount_value,
    },
    {
      id: 7,
      name: "Valid from",
      label: "valid_from",
      selector: (row) => moment(row?.valid_from).format("YYYY-MM-DD"),
      sortable: true,
      cellExport: (row) => row?.valid_from
    },
    {
      id: 8,
      name: "Valid to",
      label: "valid_to",
      selector: (row) => moment(row?.valid_to).format("YYYY-MM-DD"),
      sortable: true,
      cellExport: (row) => row.valid_to,
    },
    {
      id: 9,
      name: "Usage limit",
      label: "usage_limit",
      selector: (row) => row.usage_limit,
      sortable: true,
      cellExport: (row) => row.usage_limit,
    },
    {
      id: 10,
      name: "Usage count",
      label: "usage_count",
      selector: (row) => row.usage_count,
      sortable: true,
      cellExport: (row) => row.usage_count,
    },
    {
      id: 14,
      name: "status",
      width: "100px",
      sortable: true,
      print: false,
      cell: (row) => (
        <div className="action-btn">
          <div className="form-group">
            <div className="switch">
              <label style={{ color: "#444" }}>
                <input
                  type="checkbox"
                  id={"custom-switch" + row.id}
                  onChange={(e) => StatusChangeFunc(row.id, e.target.checked)}
                  checked={row.is_active === 1 ? true : false}
                />
                <span className="lever switch-col-green" />
              </label>
            </div>
          </div>
        </div>
      ),
    },
    {
      id: 11,
      name: "Action",
      print: false,
      selector: (row) => (
        <div className="action-btn">
          <Link
            to="/promocode-details"
            state={row}
            className="btn btn-raised bg-blue-grey waves-effect mr-1"
          >
            <i className="zmdi zmdi-eye"></i>
          </Link>
          <Link
            to={row.status === "revoked" ? "#" : "/edit-promocode"}
            state={row.status === "revoked" ? null : row}
            className={`btn btn-raised bg-light-blue waves-effect mr-1 ${row.status === "revoked" ? "disabled" : ""}`}
            style={{
              pointerEvents: row.status === "revoked" ? "none" : "auto",
              opacity: row.status === "revoked" ? 0.3 : 1,
              cursor: row.status === "revoked" ? "not-allowed" : "pointer",
            }}
          >
            <i className="zmdi zmdi-edit"></i>
          </Link>
          <button
            className="btn btn-danger col-white waves-effect mr-1"
            onClick={() => handleDeletePromocode(row.id)}
          >
            <i className="zmdi zmdi-delete"></i>
          </button>
        </div>
      ),
      width: "150px",
    },
  ];

  useEffect(() => {
     const bothDatesSelected = (startDate && endDate) || (!startDate && !endDate);

  if (bothDatesSelected) {
    getPromocodeList();
  }
  }, [search, page, perPage, sortOrder, sortColumn, discountType, startDate, endDate]);

  useEffect(() => {
    setPage(1);
    setFirst(0);
  }, [search, sortOrder, sortColumn]);

  const onPageChange = (info) => {
    setPage(info.page + 1);
    setPerPage(info.rows);
    setFirst(info.first);
  };

  const onSort = (info) => {
    if (sortColumn == info.sortField) {
      setSortOrder(sortOrder == "DESC" ? "ASC" : "DESC");
    } else {
      setSortOrder("ASC");
      setSortColumn(info.sortField);
    }
  };

  const customSortIcon = (options) => {
    let icon;
    if (options.field === sortColumn) {
      icon =
        sortOrder === "DESC" ? (
          <ArrowDropDownIcon {...options.iconProps} />
        ) : (
          <ArrowDropUpIcon {...options.iconProps} />
        );
    } else {
      icon = <SwapVertIcon {...options.iconProps} />;
    }
    return icon;
  };

  const filterDiscountType = (type) => {
    if(type === ''){
      setPromocodeFilterData(promocodeData);
    } else {
      const filterData = promocodeData.filter(promo => promo.discount_type === type)
      setPromocodeFilterData(filterData)
    }
    setDiscountType(type)
  }

  const filterDates = (dates) => {
    if(dates[0] === null){
      setPromocodeFilterData(promocodeData)
    } else {
      const filterData = promocodeData.filter(promo => moment(promo.valid_from) > moment(dates[0]) && moment(promo.valid_from) < moment(dates[1]) || moment(promo.valid_to) > moment(dates[0]) && moment(promo.valid_to) < moment(dates[1]))
      setPromocodeFilterData(filterData)
    }
  }
  const getDiscountStatus = (validTo) =>{
  return moment().isSameOrBefore(moment(validTo)) ? "Assigned" : "Expired";
}

  const getPromocodeList = async () => {
    const pageInfo = {
      filter: {
        discount_type: discountType?.length? discountType : '',
        search_text: search, 
        valid_from: startDate ? moment(startDate).format("YYYY-MM-DD") : '',
        valid_to: endDate ? moment(endDate).format("YYYY-MM-DD") : '',
      },
      pagination: {
        page: page,
        limit: perPage
      },
      donor_id : donor_id,
    };
    promocodeListAPI(pageInfo).then((res) => {
      if (res.data.code == 1) {
        isLoader(false);
        setPromocodeFilterData(res.data.promoCodes);
        setPromocodeData(res.data.promoCodes);
        setTotalRows(res.data.pagination.total);
      } else {
        isLoader(false);
        setTotalRows(0);
      }
    });
  };

  const getAssignedTo = (item) => {
    if (item.promo_code_type === 'SCHOOL_BOARD') {
      return item?.school_board_array?.map(sb => sb.school_board || "N/A").join(", ") ;
    } else if (item.promo_code_type === 'SCHOOL') {
      return item?.schools_array?.map(s => s.school_name || "N/A").join(", ");
    } else if(item.promo_code_type === 'PARENT'){
      return item?.parent_array?.map(p => p.parent_name || "N/A").join(", ");
    } 
  }


  const callExport = async () => {
    isLoader(true);
    const pageInfo = {
      filter: {
        discount_type: discountType?.length? discountType : '',
        search_text: search,
        valid_from: startDate ? moment(startDate).format("YYYY-MM-DD") : '',
        valid_to: endDate ? moment(endDate).format("YYYY-MM-DD") : '',
      },
      pagination: {
        page: page,
        limit: 10000
      },
      donor_id: donor_id,
    };

    promocodeListAPI(pageInfo).then(async(res) => {
      if (res.data.code == 1) {
        isLoader(false);
        setPromocodeFilterData(res.data.promoCodes);
        setPromocodeData(res.data.promoCodes);
        setTotalRows(res.data.pagination.total);

        var data = [];
        res.data?.promoCodes?.map((item) => {
          var colum = {
            "Promocode Id": item.id,
            "Promocode Name": item.name,
            "Unique Code": item.unique_code,
            "Discount Type": item.discount_type,
            "Discount Value": item.discount_value,
            "Valid From": moment(item.valid_from).format("YYYY-MM-DD"),
            "Valid To": moment(item.valid_to).format("YYYY-MM-DD"),
            "Allow Multiple Times": item.allow_multiple_uses === 1,
            "Minimum Order Value": item.minimum_order_value,
            "Assignment Type" : item.promo_code_type,
            "Assigned To": getAssignedTo(item),
            "Promotion Sponser Code": item.promotion_sponsor_code,
            "assign by" : item.created_by_name,
            "Usage Count": item.usage_count || 0,
            "Discount Status": getDiscountStatus(item.valid_to),
            "Created at": moment(item.created_at).format("YYYY-MM-DD HH:mm:ss"),
            "Updated at": moment(item.updated_at).format("YYYY-MM-DD HH:mm:ss"),
          };
          data.push(colum);
        })
        exportToCSV(data, `promocode_list ${Date().toString()}`);
      } else {
        isLoader(false);
        setTotalRows(0);
      }
    });
  };

  const paginationTemplate = {
    layout:
      "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink NextPageLink LastPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 15, value: 15 },
        { label: 20, value: 20 },
        { label: 25, value: 25 },
        { label: 30, value: 30 },
        { label: 50, value: 50 },
        { label: 100, value: 100 },
      ];

      return (
        <React.Fragment>
          <span
            className="mx-1"
            style={{ color: "var(--text-color)", userSelect: "none" }}
          >
            Items per page:{" "}
          </span>{" "}
          <Dropdown
            onChange={options.onChange}
            value={options.value}
            options={dropdownOptions}
          />
        </React.Fragment>
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span
          style={{
            color: "var(--text-color)",
            userSelect: "none",
            width: "120px",
            textAlign: "center",
          }}
        >
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      );
    },
    FirstPageLink: (options) => {
      return (
        <IconButton disabled={page == 1}>
          <KeyboardDoubleArrowLeftIcon
            onClick={options.onClick}
          ></KeyboardDoubleArrowLeftIcon>
        </IconButton>
      );
    },
    LastPageLink: (options) => {
      return (
        <IconButton disabled={page == Math.ceil(totalRows / perPage)}>
          <KeyboardDoubleArrowRightIcon
            onClick={options.onClick}
          ></KeyboardDoubleArrowRightIcon>
        </IconButton>
      );
    },
    NextPageLink: (options) => {
      return (
        <IconButton disabled={page == Math.ceil(totalRows / perPage)}>
          <KeyboardArrowRightIcon
            onClick={options.onClick}
          ></KeyboardArrowRightIcon>
        </IconButton>
      );
    },
    PrevPageLink: (options) => {
      return (
        <IconButton disabled={page == 1}>
          <KeyboardArrowLeftIcon
            onClick={options.onClick}
          ></KeyboardArrowLeftIcon>
        </IconButton>
      );
    },
  };

  const handleDeletePromocode = (promoId) => {
      let req = {
        promocode_id: promoId,
      }
      Swal.fire({
        title: "Do you want to Delete?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Delete",
        denyButtonText: `Don't Delete`,
      }).then(async (result)  => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const response = await deletePromocode(req);
          if (response.data.code === "1") {
            Swal.fire(response.data?.message, "", "success");
            setPromocodeFilterData(promocodeFilterData.filter((p) => p.id !== promoId));
          } else {
            Swal.fire("Not Deleted!", "", "error");
          }
        }
      });
  };

  return (
    <>
      <NavBar />
      <section className="content home">
        <Heading title="Promocode Lists" />
        <div className="container-fluid">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="card">
                <div className="body">
                  <div className="d-flex justify-content-between">
                    {/* <div className="tab-pane active" id="product_1">
                      <Link
                        to="/add-promocode"
                        className="btn btn-raised btn-default waves-effect mb-3"
                        type="button"
                      >
                        Add Promocode
                      </Link>
                    </div> */}
                    <div className="col-md-9">
                      <div className="row clearfix">
                        <div className="col-md-4">
                            <Select
                              options={discountTypeOption}
                              placeholder={"Discount type"}
                              onChange={(e) => {
                                setSelectedPromocodeType(e);
                                filterDiscountType(e?.value || '')
                              }}
                              value={selectedPromocodeType}
                              isClearable
                            />
                        </div>
                        <div className="col-md-4">
                          <div className="form-group mt-0 mb-0">
                            <div className="form-line">
                              <DatePicker
                                dateFormat={'yyyy-MM-dd'}
                                selectsRange={true}
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(update) => {
                                  setDateRange(update);
                                  setPage(1);
                                  setFirst(0);
                                  filterDates(update || "");
                                }}
                                placeholderText="Select Date"
                                className="form-control"
                                isClearable={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full float-right">
                      <button
                        className="btn btn-default waves-effect"
                        onClick={callExport}
                      >
                        Export Sheet
                      </button>
                    </div>
                  </div>
                    <div className="row">
                      <div class='details col-lg-12 col-md-12'>
                        <input
                          placeholder="Filter Table"
                          onChange={(e) => {
                            if (e.target.value.length >= 3) {
                              setSearch(e.target.value);
                            } else if (e.target.value.length == 0) {
                              setSearch("");
                            }
                          }}
                        />
                      </div>         
                    </div>
                  <div>
                    <DataTable
                      onSort={onSort}
                      sortIcon={customSortIcon}
                      value={promocodeFilterData}
                    >
                      {columns.map((col, i) => {
                        return (
                          <Column
                            key={col.name}
                            field={col.label}
                            header={col.name}
                            body={col.cell || col.selector }
                            sortable={col.sortable}
                            style={{
                              width: col.width ? col.width : "200px",
                            }}
                          />
                        );
                      })}
                    </DataTable>
                    <Paginator
                      className="float-right"
                      template={paginationTemplate}
                      first={first}
                      rows={perPage}
                      totalRecords={totalRows}
                      rowsPerPageOptions={[10, 15, 20, 25, 30]}
                      onPageChange={onPageChange}
                    ></Paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}